import { Line } from "@react-three/drei";
import { useFrame } from "@react-three/fiber";
import { useRef } from "react";

const points = [
    [-3, 0, 0],
    [-1.5, 0, 0],
    [0.5, 0, 0],
    [2.5, 0, 0],
    [4.5, 0, 0],
];

export default function WorkflowLines() {

    const lineRef = useRef();

    useFrame((state) => {

        if (!lineRef.current) return;

        const time = state.clock.elapsedTime;

        lineRef.current.material.opacity =
            0.35 + Math.sin(time * 2) * 0.15;

    });


    return (
        <Line
            ref={lineRef}
            points={points}
            color="#38bdf8"
            lineWidth={2}
            transparent
        />
    );
}
